import { Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import PasswordInput from "../widgets/PasswordInput";
import { Button } from "../ui/button";
import { useMutation } from "@tanstack/react-query";
import { showPromiseToast } from "src/lib/utils";
import { usePortalContext } from "src/context/PortalContext";
import { updatePassword } from "src/api/settings";
import { useAuth } from "src/providers/AuthProvider";
import { changeDefaultPassword } from "src/api";

const initialValues = {
	current_password: "",
	new_password: "",
	new_password_confirmation: "",
};
const validationSchema = Yup.object().shape({
	current_password: Yup.string().required("Old password is required"),
	new_password: Yup.string().required("New password is required"),
	new_password_confirmation: Yup.string()
		.required("This field is required")
		.oneOf([Yup.ref("new_password")], "Passwords must match"),
});

const UpdatePassword = ({ isForDefault }) => {
	const { logout } = useAuth();
	const closePortal = usePortalContext();

	const { mutate, isLoading } = useMutation(isForDefault ? changeDefaultPassword : updatePassword, {
		onSuccess: ({ message }) => {
			closePortal();
			const promise = () => new Promise((resolve) => setTimeout(() => resolve(logout()), 2500));
			showPromiseToast(promise, {
				loading: message,
				description: "You'll be logged out soon",
				success: () => ({ message: "Please login again" }),
				error: "Error",
			});
		},
	});
	return (
		<Formik
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={(values) => {
				if (isForDefault) {
					mutate(values);
				} else {
					const { new_password_confirmation, ...rest } = values;
					mutate(rest);
				}
			}}
		>
			{({ values, handleChange, handleSubmit }) => (
				<form onSubmit={handleSubmit} className="tw-grid tw-gap-5">
					<PasswordInput
						className="formItem !tw-w-full !tw-mb-0"
						label="Current password"
						name="current_password"
						type="password"
						placeholder="Current password"
						value={values.current_password}
						onChange={handleChange}
					/>
					<PasswordInput
						className="formItem !tw-w-full !tw-mb-0"
						label="New password"
						name="new_password"
						type="password"
						placeholder="New password"
						value={values.new_password}
						onChange={handleChange}
					/>
					<PasswordInput
						className="formItem !tw-w-full !tw-mb-0"
						label="Confirm password"
						name="new_password_confirmation"
						type="password"
						placeholder="Confirm password"
						value={values.new_password_confirmation}
						onChange={handleChange}
					/>
					<Button className="tw-w-full" variant="secondary" disabled={isLoading}>
						{isLoading ? "Updating..." : "Update Password"}
					</Button>
				</form>
			)}
		</Formik>
	);
};

export default UpdatePassword;
